import axios from "axios";
import ReusableDataTable from "../../components/ReusableDataTable";
import { Link } from "react-router-dom";
import apiRequest from '../../services/apiService';


const SocialServiceTable = ({category}) => {

    const api_endpoint = `${process.env.REACT_APP_API_URL}/socialservice`;

    const columns = [
        { id: 'id', field: 'id', headerName: 'ID' },
        { id: 'client_fullname', field: 'client_fullname', headerName: 'Client Name' },
        { id: 'beneficiary_fullname', field: 'beneficiary_fullname', headerName: 'Beneficiary Name' },
        { id: 'beneficiary_email', field: 'beneficiary_email', headerName: 'Email' },
        { id: 'beneficiary_district', field: 'beneficiary_district', headerName: 'District' },
        { id: 'beneficiary_municipality', field: 'beneficiary_municipality', headerName: 'Municipality' },
    ];
    
    const actions = [
        { label: 'Edit', link: './update', icon: 'bx bx-edit-alt me-1' },
    
    ];
    
    const other_actions = [
        { label: 'View', link: '/delete', icon: 'bx bx-detail me-1' },
    ];
    

    const fetchData = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm }) => {
        const params = {
            page     : page,
            page_size: rowsPerPage,
            ordering : sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}`: undefined,
            search   : searchTerm || undefined,
        };
    
        return await apiRequest('GET', `/socialservice/?ss=${category}`, null, params);
    };
 

    return (
        <>
            <ReusableDataTable
                fetchDataFn={fetchData}
                columns={columns}
                actions={actions}
                other_actions={other_actions}
                onViewDetails=""
                deleteEndpoint={api_endpoint}
                tableTitle="List of Beneficiaries"
            />
        </>
    );
}

export default SocialServiceTable;